import Swiper, {Pagination, FreeMode} from "swiper";

export default (el) => {
  const promotionEl = el.querySelector('.js-promotion')

  new Swiper(promotionEl, {
    modules: [Pagination, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: {
      enabled: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  })
}
